var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.2272 3.2274c.7029-.70294 1.8426-.70294 2.5455 0 .703.70295.703 1.84264 0 2.54559l-.7136.7136-2.5455-2.54558z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.2408 5.2138-7.54085 7.5408v2.5456h2.54558l7.54077-7.54082z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.772e8de35669b6840108dc4012f231a3.svg";
export { ForwardRef as ReactComponent };